import { Button, Stack, Typography } from '@mui/material'
import { memo } from 'react'
import { RefreshRounded } from '@mui/icons-material'
import IvMultiplierButton from '../payoffChart/ivMultiplierButton'
import LivePayoffTargetPnl from './livePayoffTargetPnl'
import TargetDateInput from './targetDateInput'
import TargetPriceInput from './targetPriceInput'

export type Props = {
    ivMultiplier: number,
    onIvMultiplierChange: (newIvMultiplier: number) => void
    onSpotTargetPriceChange: (price: number) => void
    spotTargetPrice: number,
    baseTimestamp: number,
    targetTimestamp: number,
    nearestExpiry: number,
    setTargetDate: (date: number) => void,
    handleResetParams: ()=>void
    tickSize?: number
    minStrike?: number
    maxStrike?: number
}

const PayoffTargetControls = ({
    ivMultiplier,
    baseTimestamp,
    targetTimestamp,
    nearestExpiry,
    setTargetDate,
    onIvMultiplierChange,
    onSpotTargetPriceChange,
    spotTargetPrice,
    handleResetParams,
    tickSize,
    minStrike,
    maxStrike
}: Props) => {
    return (
        <Stack direction={'row'} sx={{ display: 'flex', flexWrap: 'wrap', py: 1, px: 2, justifyContent: 'space-between', gap: 1, gridArea: 'header' }} alignItems={'center'}>
            <Stack direction={'row'} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 2 }} alignItems={'center'}>
                <IvMultiplierButton ivMultiplier={ivMultiplier} handleIvMultiplierChange={onIvMultiplierChange} />
                <TargetPriceInput 
                    setTargetPrice={onSpotTargetPriceChange} 
                    price={spotTargetPrice}
                    tickSize={tickSize}
                    minStrike={minStrike}
                    maxStrike={maxStrike}
                />
                <TargetDateInput
                    baseTimestamp={baseTimestamp}
                    nearestExpiry={nearestExpiry}
                    targetTimestamp={targetTimestamp}
                    setTargetDate={setTargetDate}
                />
                <Button data-event={'Reset strategy builder target params Clicked'} data-event-source={'strategy builder'} variant="text"
                    className="reset-prices"
                    onClick={handleResetParams}
                    startIcon={<RefreshRounded className="reset-prices-icon" />} size={'small'}
                    sx={{ mt: '15px' }}
                >
                    Reset
                </Button>
            </Stack>
            <LivePayoffTargetPnl />
        </Stack>
    )
}

export default memo(PayoffTargetControls)
